<template>
	<v-img
		:src="url"
		:lazy-src="url"
		:aspect-ratio="4 / 3"
		contain
		width="100"
		height="75"
	></v-img>
</template>

<script>
export default {
	props: {
		value: {
			default: null,
			required: true,
		},
	},

	computed: {
		url() {
			return this.value
				? this.value.url
				: "/images/image_placeholder.jpg";
		},
	},
};
</script>
